import api from './interceptor'

// 获取精选配置详情
export const getChoiceConfigDetails = params => {
  return api.get('/customer/choiceConfig/getCustomerChoiceConfigDetails', { params })
}
